import React, { useEffect, useRef, useState } from "react";
import { Badge, Container, Card, CardBody, Row, Col, Button } from "reactstrap";
import DynamicFormModal from "components/Modal/Form";
import { dealTabFormFields } from "variables/formFields";
// import { showAlert } from "components/Common/commonFunctions";
import Breadcrumbs from "components/BreadCrumb/Breadcrumbs";
import { useLocation } from "react-router-dom";
import { getDealDetailsById } from "actions/deal";
import NotificationAlert from "react-notification-alert";
import { tagDetails } from "actions/tag";
import { getPublisherList } from "actions/publisher";
import { getProductTypeList, getProductTypeListByPublisherID } from "actions/productType";
import { updateDeal } from "actions/deal";
import moment from "moment";

const DealDetails = ({ dealId, onClose }) => {
  // Static data
  const [deal, setDeal] = useState();
  const isEditMode = true;
  // Single tag object instead of array
  const [tag, setTag] = useState({});
  const location = useLocation();
  const dealData = location.state || null;
  const [showEditModal, setShowEditModal] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [dropDownData, setDropDownData] = useState({
    publisherData: [],
    productTypeData: [],
  
  });
  const [dropDownOtherData, setdropDownOtherData] = useState({
    publisherData: { pageNum: 1, searchString: "", totalRecords: 0 },
 
    productTypeData: { pageNum: 1, searchString: "", totalRecords: 0 },
  });
  const [showCreateTagWarning, setshowCreateTagWarning] = useState(false);
  const notificationAlertRef = useRef(null);
  const [formState, setFormState] = useState({
    values: { ...deal },
    errors: {},
  });
  const [initialFormValues, setInitialFormValues] = useState({});


  React.useEffect(() => {
    let isMounted = true;

    const fetchProductTypes = async () => {
      if (!formState?.values?.publisher_name) {
        setDropDownData((prev) => ({
          ...prev,
          productTypeData: [],
        }));
        return;
      }

      try {
        const productTypeRes = await getProductTypeListByPublisherID(formState.values.publisher_name);

        // Only update state if component is still mounted
        if (isMounted) {
          const productTypeData = productTypeRes?.code === 200
            ? (productTypeRes?.data?.ProductType || []).map((item) => ({
              label: item?.name || "",
              value: item?.ID,
            }))
            : [];

          setDropDownData((prev) => ({
            ...prev,
            productTypeData: productTypeData,
          }));
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching product types:", error);
          setDropDownData((prev) => ({
            ...prev,
            productTypeData: [],
          }));
        }
      }
    };

    fetchProductTypes();

    return () => {
      isMounted = false; // Cleanup function to prevent memory leaks
    };
  }, [formState?.values?.publisher_name]);

  //==> handleEdit function is used for open edit modal to edit deal.
  const handleEdit = async () => {
    const loadedValues = {
      name: deal.name,
      publisher_name: deal.publisher?.ID,
      product_type: deal?.productTypeID?.ID,
      platform: deal.platform?.ID,
      status: deal.status === "ACTIVE",
      revenueShare: deal?.dealType === "REVENUE_SHARE" && deal.dealTypeValue,
      demandPartner:deal.demandPartner,
      ecpm: deal.dealType === "ECPM" && deal.dealTypeValue,
      dealType: deal.dealType,
      adUnitCodes: Array.isArray(deal.adUnitCodes)
        ? deal.adUnitCodes
        : deal.adUnitCodes
          ? deal.adUnitCodes
          : deal.gamNetworkID
            ? Array.isArray(deal.gamNetworkID)
              ? deal.gamNetworkID
              : [deal.gamNetworkID]
            : deal.adUnitCode
              ? [deal.adUnitCode]
              : [],
      start_date: deal.startDate ? new Date(deal.startDate) : "",
    };

    // Fetch and load tag info if tag exists
    if (deal?.dealTagID && deal?.dealTagID !== 0) {
      try {
        const tagRes = await tagDetails(deal?.dealTagID);
        if (tagRes?.code === 200) {
          loadedValues.tag_name = tagRes?.data.tagName;
          loadedValues.tag_content = tagRes?.data.content;
          loadedValues.tstatus = tagRes?.data.status === "ACTIVE";
          setshowCreateTagWarning(false);
          setTag(tagRes?.data);
        } else {
          setshowCreateTagWarning(true);
          loadedValues.tag_name = "";
          loadedValues.tag_content = "";
          loadedValues.tstatus = true;
        }
      } catch (error) {
        setshowCreateTagWarning(true);
        loadedValues.tag_name = "";
        loadedValues.tag_content = "";
        loadedValues.tstatus = true;
      }
    } else {
      setshowCreateTagWarning(true);
      loadedValues.tag_name = "";
      loadedValues.tag_content = "";
      loadedValues.tstatus = true;
    }

    setFormState({
      values: loadedValues,
      errors: {},
    });
    setInitialFormValues(loadedValues);
    getDropDownData();
    setShowEditModal(true);
  };

  //==> handleSubmit function is used for update the deal details.
  const handleSubmit = async (e) => {
    e.preventDefault();
    setshowLoader(true);
    try {
      const payLoad = getChangedPayload(formState.values, initialFormValues);

      if (Object.keys(payLoad).length === 0) {
        notify("info", "No changes detected.");
        setshowLoader(false);
        return;
      }

      const res = await updateDeal(dealData?.ID, payLoad);
      if (res.code === 200) {
        notify("success", res?.message);
        setshowLoader(false);
        getDealDetails();
        setShowEditModal(false);
      } else {
        setshowLoader(false);
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", "Something went wrong");
      setshowLoader(false);
    }
  };


  //=> getTagDetailsByDealID function is used for get tag deatils bby deal Id in edit mode.
  const getTagDetailsByDealID = async () => {
    try {
      const res = await tagDetails(dealData?.dealTagID);
      if (res?.code === 200) {
        setFormState((prev) => ({
          ...prev,
          values: {
            ...prev.values,
            tag_name: res?.data.tagName,
            tag_content: res?.data.content,
            tstatus: res?.data.status === "ACTIVE",
          },
          errors: {},
        }));
      } else {
        setFormState((prev) => ({
          ...prev,
          values: {
            ...prev.values,
            tstatus: true,
          },
          errors: {},
        }));
        setshowCreateTagWarning(true);
      }
    } catch (error) { }
  };

  //=> handleInputChange function is used for set the form values in a state.
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormState((prev) => {
      let updatedErrors = { ...prev.errors, [name]: "" };

      // 🔥 Revenue Share validation (max 100)
      if (name === "revenueShare") {
        const numericValue = Number(value);

        if (value === "") {
          updatedErrors.revenueShare = "";
        } else if (isNaN(numericValue)) {
          updatedErrors.revenueShare = "Revenue share must be a number";
        } else if (numericValue > 100) {
          updatedErrors.revenueShare = "Revenue share cannot exceed 100";
        }
      }

      return {
        values: { ...prev.values, [name]: value },
        errors: updatedErrors,
      };
    });

    // Existing logic
    if (name === "create_tag" && value === true) {
      getTagDetailsByDealID();
    }
  };

  const normalizeDealPayload = (values) => {
    if (!values) return {};

    const payload = {
      ...(values.name !== undefined && { name: values.name }),
      ...(values.publisher_name !== undefined && {
        publisherID: values.publisher_name,
      }),
      ...(values.platform !== undefined && { platformID: values.platform }),
      ...(values.adUnitCodes !== undefined && { adUnitCodes: values.adUnitCodes }),
      ...(values.adUnitCodes !== undefined && values.adUnitCodes.length > 0 && { adUnitCode: values.adUnitCodes[0] }),
      ...(values.product_type !== undefined && {
        productTypeID: values.product_type,
      }),
       ...(values.demandPartner!==undefined&&{demandPartner:values?.demandPartner}),
      ...(values.dealType !== undefined && { dealType: values.dealType }),
      ...(values.dealType !== undefined && {
        dealTypeValue:
          values.dealType === "ECPM"
            ? parseFloat(values.ecpm)
            : parseFloat(values.revenueShare),
      }),
      ...(values.status !== undefined && {
        status: values.status ? "ACTIVE" : "INACTIVE",
      }),
      ...(values.start_date !== undefined && {
        startDate: values.start_date
          ? moment(values.start_date).format("YYYY-MM-DD")
          : "",
      }),
      ...(values.create_tag !== undefined && { createTag: values.create_tag }),
    };

    if (values.create_tag) {
      const tagID = deal?.dealTagID || tag?.ID || dealData?.dealTagID;
      payload.tag = {
        ...(tagID && { ID: tagID }),
        publisherID: values.publisher_name,
        name: values.tag_name,
        content: values.tag_content,
        status: values.tstatus ? "ACTIVE" : "INACTIVE",
      };
    }

    return payload;
  };

  const getChangedPayload = (currentValues, originalValues) => {
    const currentPayload = normalizeDealPayload(currentValues);
    const originalPayload = normalizeDealPayload(originalValues);
    return Object.entries(currentPayload).reduce((acc, [key, value]) => {
      if (key === "tag") {
        const originalTag = originalPayload.tag || {};

        const changedTag = Object.entries(value).reduce(
          (tagAcc, [tagKey, tagValue]) => {
            if (tagValue !== originalTag[tagKey]) {
              tagAcc[tagKey] = tagValue;
            }

            return tagAcc;
          },
          {},
        );

        if (Object.keys(changedTag).length > 0) {
          acc.tag = changedTag;
        }

        return acc;
      }

      const originalValue = originalPayload[key];

      const valuesDiffer =
        value !== originalValue &&
        !(Number.isNaN(value) && Number.isNaN(originalValue));

      if (valuesDiffer) {
        acc[key] = value;
      }

      return acc;
      }, {
      productTypeID: currentValues?.product_type,
            publisherID:originalValues.publisher_name,
            demandPartner:currentValues.demandPartner,
    });
  };

  // const handleTagEdit = () => {
  //   // Handle tag edit logic here
  //   showAlert({
  //     title: "Edit Tag",
  //     message: "Edit tag functionality would open here",
  //     type: "info",
  //   });
  // };

  //=== Api Call to get Deatils
  useEffect(() => {
    getDealDetails();
  }, []);

  //=> getDealDetails function is used for get Deal details by deal id.
  const getDealDetails = async () => {
    try {
      const res = await getDealDetailsById(dealData?.ID);
      if (res.code === 200) {
        setDeal(res?.data);
        
        // Fetch tag details using the updated dealTagID from response
        if (res?.data?.dealTagID && res?.data?.dealTagID !== 0) {
          try {
            const tagRes = await tagDetails(res?.data?.dealTagID);
            if (tagRes?.code === 200) {
              setTag(tagRes?.data);
              setshowCreateTagWarning(false);
            } else {
              setTag({});
              setshowCreateTagWarning(true);
            }
          } catch (tagError) {
            setTag({});
            setshowCreateTagWarning(true);
          }
        } else {
          setTag({});
          setshowCreateTagWarning(true);
        }
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", error?.message);
    }
  };

  //===> notify function is used for to show notification on create and update the deal.
  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  //==> getStatusBadge function is used for show status style.
  const getStatusBadge = (status) => {
    const colors = {
      ACTIVE: "#28a745",
      INACTIVE: "#f73832ff",
      PENDING: "#ffc107",
      EXPIRED: "#dc3545",
    };

    return (
      <Badge
        style={{
          color: colors[status] || "#6c757d",
          backgroundColor: "white",
          marginLeft: "-7px",
          // padding: "8px 16px",
          //   borderRadius: "4px",
          fontSize: "14px",
          fontWeight: "normal",
        }}
      >
        {status}
      </Badge>
    );
  };

  const VerticalField = ({ label, value, children }) => (
    <div style={{ marginBottom: "20px" }}>
      <div
        style={{
          fontSize: "14px",
          color: "#6c757d",
          marginBottom: "5px",
          fontWeight: "500",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: "16px",
          color: "#333",
          fontWeight: "500",
        }}
      >
        {value || children}
      </div>
    </div>
  );

  //==> getRevenueShareNumber is used for get round off percentage.
  const getRevenueShareNumber = (value) => {
    if (!value) return 0;

    // "70:30%" → 70
    const match = String(value).match(/^(\d+)/);
    return match ? Number(match[1]) : 0;
  };

  const revenue = getRevenueShareNumber(deal?.revenueShare);

  //==> getDropDownData is used for fetch the list through api and patch to dropdown options.
  const getDropDownData = async () => {
    try {
      const [publisherRes, productTypeRes] = await Promise.all([
        getPublisherList(
          dropDownOtherData.publisherData.pageNum,
          [],
          dropDownOtherData.publisherData.searchString,
        ),
       

      ]);
      const publisherData =
        publisherRes?.code === 200
          ? (publisherRes?.data?.Publisher || []).map((item) => ({
            label: item?.companyName || "",
            value: item?.ID,
          }))
          : [];
    



      
      setDropDownData((prev) => ({
        ...prev,

     
        publisherData: publisherData,
      }));
      setdropDownOtherData({
        productTypeData: {
          totalRecords: productTypeRes?.data?.totalRecords,
          pageNum: 1,
          searchString: "",
        },
        publisherData: {
          totalRecords: publisherRes?.data?.totalRecords,
          pageNum: 1,
          searchString: "",
        },
      });
    } catch (error) {
      console.error("Dropdown API error:", error?.message);
      // notify("danger", "Something went wrong while loading dropdown data");
    }
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Container fluid className="mt--6">
        <Card className="shadow-sm">
          <Breadcrumbs />
          <Row>
            <Col md={12}>
              {/* Main Card */}
              {/* <Card
                style={{
                  marginBottom: "20px",
                  borderRadius: "4px",
                  borderBottom: "1px solid #dee2e6",
                }}
              > */}
              <CardBody style={{ padding: "20px" }}>
                {/* Deal Header */}
                <div style={{ marginBottom: "30px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#333",
                        marginBottom: "10px",
                      }}
                    >
                      {deal?.name}
                    </div>
                    <Button
                      className="btn-gradient-primary"
                      size="sm"
                      onClick={handleEdit}
                    >
                      Edit Deal
                    </Button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <span style={{ color: "#666" }}>
                      <i className="fas fa-building mr-1"></i>
                      {deal?.publisher.name || "-"}
                    </span>
                    {getStatusBadge(deal?.status)}
                  </div>
                </div>

                <Row>
                  <Col md={12}>
                    <h3
                      style={{
                        marginBottom: "20px",
                        color: "#333",
                        paddingBottom: "10px",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      Deal Details
                    </h3>

                    <Row>
                      <Col md={6}>
                        <VerticalField
                          label="Publisher"
                          value={deal?.publisher?.companyName || "-"}
                        />
                      </Col>
  
                    </Row>

                    <Row>
                      <Col md={6}>
                        <VerticalField
                          label="Product Type"
                          value={deal?.productTypeID?.name}
                        />
                      </Col>
                      <Col md={6}>
                        <VerticalField
                          label="Ad Unit Codes"
                          value={
                            Array.isArray(deal?.adUnitCodes) ? (
                              <div>
                                {deal.adUnitCodes.map((id, index) => (
                                  <div key={index}>• {id}</div>
                                ))}
                              </div>
                            ) : (
                              deal?.adUnitCodes || deal?.gamNetworkID || deal?.adUnitCode || "-"
                            )
                          }
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <VerticalField
                          label="Created Date"
                          value={deal?.createdAt || "-"}
                        />
                      </Col>
                      <Col md={6}>
                        <VerticalField
                          label="Deal Type"
                          value={deal?.dealType}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <VerticalField
                          label="Deal Type Value"
                          value={deal?.dealTypeValue || "0"}
                        />
                      </Col>
                       <Col md={6}>
                        <VerticalField
                          label="Demand Partner"
                          value={deal?.demandPartner || "-"}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* Tag Information Section */}
                {Object.keys(tag).length > 0 && (
                  <div style={{ marginTop: "40px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "20px",
                        borderBottom: "1px solid #dee2e6",
                        paddingBottom: "10px",
                      }}
                    >
                      <h3 style={{ margin: 0, color: "#333" }}>
                        Tag Information
                      </h3>
                      {/* <Button color="primary" onClick={handleTagEdit}>
      Edit Tag
    </Button> */}
                    </div>

                    <Row>
                      <Col md={6}>
                        <VerticalField label="Tag Name" value={tag?.tagName} />
                        <VerticalField label="Status">
                          {getStatusBadge(tag?.status)}
                        </VerticalField>
                      </Col>

                      <Col md={6}>
                        {/* <VerticalField
                        label="Floor Price"
                        value={tag.floor_price}
                      /> */}
                        <VerticalField label="Version" value={tag?.version} />
                      </Col>
                      <Col md={12}>
                        <VerticalField
                          label="Tag Content"
                          value={tag?.content}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </CardBody>
              {/* </Card> */}
            </Col>

            {/* Sidebar */}
            {/* <Col md={4}> */}
            {/* Quick Stats */}
            {/* <Card style={{ marginBottom: "20px", borderRadius: "4px", border: "1px solid #dee2e6" }}>
              <CardBody style={{ padding: "20px" }}>
                <h5 style={{ 
                  marginBottom: "20px", 
                  color: "#333", 
                  paddingBottom: "10px",
                  borderBottom: "1px solid #dee2e6"
                }}>
                  Quick Stats
                </h5>
                
                <VerticalField label="Budget Utilization">
                  <div>
                    <div style={{ marginBottom: "5px" }}>65% ($32,500/$50,000)</div>
                    <div style={{ 
                      height: "8px", 
                      backgroundColor: "#e9ecef", 
                      borderRadius: "4px",
                      overflow: "hidden",
                      width: "100%"
                    }}>
                      <div 
                        style={{ 
                          width: "65%", 
                          height: "100%",
                          backgroundColor: "#28a745"
                        }}
                      />
                    </div>
                  </div>
                </VerticalField>
                
                <VerticalField label="Days Remaining" value="72 days" />
                <VerticalField label="Average Daily Spend" value="$541.67" />
                <VerticalField label="Performance Rating" value="Good" />
              </CardBody>
            </Card> */}

            {/* Actions Card */}
            {/* <Card style={{ borderRadius: "4px", border: "1px solid #dee2e6" }}>
              <CardBody style={{ padding: "20px" }}>
                <h5 style={{ 
                  marginBottom: "20px", 
                  color: "#333", 
                  paddingBottom: "10px",
                  borderBottom: "1px solid #dee2e6"
                }}>
                  Quick Actions
                </h5>
                
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  <Button color="success" style={{ padding: "10px" }}>
                    <i className="fas fa-chart-line mr-2"></i>
                    View Reports
                  </Button>
                  <Button color="info" style={{ padding: "10px" }}>
                    <i className="fas fa-file-export mr-2"></i>
                    Export Data
                  </Button>
                  <Button color="warning" style={{ padding: "10px" }}>
                    <i className="fas fa-clock mr-2"></i>
                    Schedule Review
                  </Button>
                  <Button color="secondary" style={{ padding: "10px" }}>
                    <i className="fas fa-history mr-2"></i>
                    View History
                  </Button>
                </div>
              </CardBody>
            </Card> */}
            {/* </Col> */}

          </Row>
          <Col md={12} style={{ marginBottom: "30px" }}>
            <table className="table table-bordered table-striped" >
              <thead>
                <tr>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Deal Type</th>
                  <th>Deal Type Value</th>
                </tr>
              </thead>

              <tbody>
                {deal?.dealDates?.length > 0 ? (
                  deal.dealDates.map((dateObj, index) => (
                    <tr key={index}>
                      <td>{dateObj?.startDate || "-"}</td>
                      <td>{dateObj?.endDate || "-"}</td>
                      <td>{dateObj?.dealType || "-"}</td>
                      <td>{dateObj?.dealTypeValue || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Col>
        </Card>
      </Container>

      {/* Edit Modal */}
      <DynamicFormModal
        isOpen={showEditModal}
        toggle={() => setShowEditModal(false)}
        title="Edit Deal"
        fields={dealTabFormFields(
          dropDownData?.publisherData,
          dropDownData?.productTypeData,
          isEditMode,
        )}
        formData={formState.values}
        errors={formState.errors}
        onChange={handleInputChange}
        onSubmit={handleSubmit}
        tagError={
          showCreateTagWarning === true &&
            "Edit Deal" &&
            formState.values.create_tag === true
            ? "Tag is not created against this deal."
            : ""
        }
        showLoader={showLoader}
        isEditMode={isEditMode}
        previousDealDates={deal?.dealDates || []}
      />
    </>
  );
};

export default DealDetails;
